import React, { useMemo } from 'react';
import { ToolTipWrapper, CloseIcon, ToolTipContent, ObjectKey } from './tooltip.styles';

const Tooltip = ({
  x,
  y,
  entityObject,
  closeTooltip
}) => {
  const xCoordinate = useMemo(() => x, [x]);
  const yCoordinate = useMemo(() => y, [y]);

  const convertCamel = string => {
    var result = string.replace(/([A-Z])/g, ' $1');
    var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    const modifiedResult = finalResult[0] === ' ' ? finalResult.substring(1) : finalResult;
    return modifiedResult;
  };

  const getStyles = (x, y) => {
    return {
      position: 'absolute',
      left: x + 20,
      top: y,
      zIndex: 100
    };
  };

  const getPropertyName = key => {
    switch (key) {
      case 'Label':
        return 'Object Type';

      case 'Label Name':
      case 'Resource Name':
        return 'Name';

      case 'User Native Id':
      case 'Resource Native Id':
        return 'Native Id';

      default:
        return key;
    }
  };

  if (entityObject && Object.keys(entityObject).length && xCoordinate && yCoordinate) {
    return /*#__PURE__*/React.createElement(ToolTipWrapper, {
      style: getStyles(xCoordinate, yCoordinate)
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      onClick: closeTooltip
    }, "x"), /*#__PURE__*/React.createElement(ToolTipContent, null, Object.keys(entityObject).map((property, index) => {
      if (property !== 'FROM' && property !== 'TO' && property !== 'UserAccountName' && property !== 'ResourceName' && property !== 'PolicyName') {
        return /*#__PURE__*/React.createElement("div", {
          key: index
        }, /*#__PURE__*/React.createElement(ObjectKey, null, getPropertyName(convertCamel(property))), /*#__PURE__*/React.createElement("div", null, `${typeof entityObject[property] === 'object' ? JSON.stringify(entityObject[property]) : entityObject[property]}`));
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null);
    })));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};

export default Tooltip;